import React, { useCallback } from 'react';
import { Button, CircularProgress, Icon, IconButton } from '@medely/ui-kit';
import { useMaskedPhoneNumberMutations } from '@mp/hooks';
import useDialog from '@mp/hooks/useDialog';
import { CallFacilityDialog } from './CallFacilityDialog';

type ContactFacilityProps = {
  phone?: string | null;
  contactableId?: number | null;
  type: 'job' | 'assignment';
  smallIcon?: boolean;
  isIconButton?: boolean;
};

const ContactFacility = ({
  contactableId,
  phone,
  type,
  smallIcon = false,
  isIconButton = false,
}: ContactFacilityProps) => {
  const { requestJobMaskedNumber, requestAssignmentMaskedNumber, isLoading } =
    useMaskedPhoneNumberMutations();
  const { open, openDialog, closeDialog } = useDialog();

  const handleCall = useCallback(() => {
    if (!phone && contactableId) {
      if (type === 'job') {
        requestJobMaskedNumber(contactableId as number, { onSuccess: openDialog });
      } else {
        requestAssignmentMaskedNumber(contactableId as number, {
          onSuccess: openDialog,
        });
      }
    } else {
      openDialog();
    }
  }, [contactableId, phone]);

  const iconSize = smallIcon ? '14px' : '20px';
  const spinnerSize = smallIcon ? 14 : 20;

  return (
    <>
      {isIconButton ? (
        <IconButton
          tooltip="Call facility"
          variant="contained"
          color="secondary"
          disabled={isLoading}
          icon={
            isLoading ? (
              <CircularProgress size={spinnerSize} testId="contact-facility-loading" />
            ) : (
              <Icon name="light-phone" iconSize={iconSize} color="text.primary" variant="custom" />
            )
          }
          onClick={handleCall}
        />
      ) : (
        <Button
          fullWidth
          variant="outlined"
          loading={isLoading}
          onClick={handleCall}
          testId="contact-facility-button"
          startIcon={
            <Icon name="phone" iconSize={iconSize} color="text.primary" variant="custom" />
          }
        >
          Call facility
        </Button>
      )}

      <CallFacilityDialog open={open} onClose={closeDialog} phone={phone} />
    </>
  );
};

export default ContactFacility;
